// Generated P layer lookup table
// Contains flattened taxonomy for Personalize

export const P_LAYER_LOOKUP = {
  FAC: {
    numericCode: '001',
    name: 'Face',
  },
  'FAC.SWP': {
    numericCode: '001',
    name: 'Swap',
  },
  VOI: {
    numericCode: '002',
    name: 'Voice',
  },
  'VOI.MOD': {
    numericCode: '001',
    name: 'Modulation',
  },
};

export const P_SUBCATEGORIES = {
  FAC: ['FAC.SWP'],
  VOI: ['VOI.MOD'],
};
